import React, {useEffect} from "react";
import {getEmails, getEmailsAfter} from "store/actions/Emails";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {RootState} from "store/store";
import {EmailState} from "store/reducers/Emails";

interface Actions {
    emails: EmailState;
    getEmails: () => void;
    getEmailsAfter: (date: number) => void;
}

const EmailFetcher: React.FC<Actions> = ({ emails, getEmails, getEmailsAfter }) => {

    useEffect(() => {
        const refresh = () => {
            //@ts-ignore
            const newest = emails.getNewestEmail();
            if (newest !== null) {
                getEmailsAfter(newest.date)
            } else {
                getEmails()
            }
        };

        // Web push is the realtime path. The interval remains as a fallback
        // for browsers/users without an active push subscription.
        const onServiceWorkerMessage = (event: MessageEvent) => {
            if (event.data?.source === "office-push" && event.data?.type === "mail") {
                refresh();
            }
        };
        const onVisibilityChange = () => {
            if (document.visibilityState === "visible") {
                refresh();
            }
        };

        navigator.serviceWorker?.addEventListener("message", onServiceWorkerMessage);
        document.addEventListener("visibilitychange", onVisibilityChange);
        const interval = window.setInterval(refresh, 20000);

        return () => {
            window.clearInterval(interval);
            navigator.serviceWorker?.removeEventListener("message", onServiceWorkerMessage);
            document.removeEventListener("visibilitychange", onVisibilityChange);
        }
    }, [emails, getEmails, getEmailsAfter])

    return <></>;
};


const mapStateToProps = (state: RootState) => {
    return {
        emails: state.Emails,
    };
};

const mapDispatchToProps = (dispatch: any) => {
    return bindActionCreators({ getEmails, getEmailsAfter }, dispatch);
};


export default connect(mapStateToProps, mapDispatchToProps)(EmailFetcher);
